import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_services';
import { NotificationsService } from "src/app/shared/notifications.service";


@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  currentUser: any;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private notifyService: NotificationsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.currentUser = this.authenticationService.currentUserValue;

    if (this.currentUser) {
      this.checkUserAuth(route);
      
			// logged in so return true
			return true;
    }

    if (state.url.indexOf("/conteudo") > 0 && state.url.substr(-9) === "/arquivos") {
      this.router.navigate(["login", state.url.replace(/\D+/g, "")]);
      return false;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(["login"]);
    return false;
  }

  checkUserAuth(route: any) {
    if (this.currentUser.role) {      
      if (route.data.role && route.data.role.indexOf(this.currentUser.role) === -1) {
        this.notifyService.showError('Você não possui autorização para acessar esta página', 'Acesso negado');
        this.router.navigate(["/home"]);
        return false;
      }  

    }
  }
}
